import { Routes } from '@angular/router';
import { KeycloakGuard } from '@shared/guards/keycloak/keycloak.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'private',
    loadChildren: () => import('./private/private.routes').then(m => m.PRIVATE_ROUTES),
    canActivate: [KeycloakGuard],
    canMatch: [KeycloakGuard],
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'not-found',
    loadComponent: () => import('@shared/pages/not-found/not-found.page').then(m => m.NotFoundPage),
  },
  {
    path: 'cancelado',
    loadChildren: () => import('./public/public.routes').then(m => m.PUBLIC_ROUTES),
  },
  { path: '**', redirectTo: '/not-found' },
];
